const MEDIA_CACHE_NAME = 'mogym-media-cache-v1';

export async function cacheMediaUrl(url) {
  if (!url) return null;

  const cache = await caches.open(MEDIA_CACHE_NAME);
  const cached = await cache.match(url);

  if (cached) return url;

  const res = await fetch(url, { mode: 'cors' });

  if (!res.ok) {
    throw new Error('media_cache_failed');
  }

  await cache.put(url, res.clone());
  return url;
}

export async function getCachedMediaUrl(url) {
  if (!url) return null;

  const cache = await caches.open(MEDIA_CACHE_NAME);
  const cached = await cache.match(url);

  if (!cached) return null;

  const blob = await cached.blob();
  return URL.createObjectURL(blob);
}

export async function cacheWorkoutVideos(workoutDays = [], warmup = []) {
  const urls = [];

  workoutDays.forEach((day) => {
    day?.WorkoutGroups?.forEach((group) => {
      group?.ExerciseRecords?.forEach((ex) => {
        if (ex?.VideoUrl) urls.push(ex.VideoUrl);
      });
    });
  });

  warmup.forEach((item) => {
    if (item?.VideoUrl) urls.push(item.VideoUrl);
  });

  const uniqueUrls = [...new Set(urls.filter(Boolean))];

  await Promise.allSettled(uniqueUrls.map((url) => cacheMediaUrl(url)));
}